import actionTypes from './actionTypes2';
import getActionCreator from '../libs/getActionCreator';

export const setTable2 = getActionCreator(actionTypes.SET_TABLE_2);
export const setLegenda2 = getActionCreator(actionTypes.SET_LEGENDA2);
export const setSituation2 = getActionCreator(actionTypes.SET_SITUATION_2);
export const setFirstPairCardTableFold2 = getActionCreator(actionTypes.SET_FIRST_PAIR_2);
export const setSecondPairCardTableFold2 = getActionCreator(actionTypes.SET_SECOND_PAIR_2);
export const setPurple2 = getActionCreator(actionTypes.SET_PURPLE_2);

export const setCard12 = (payload) => ({
  type: actionTypes.SET_CARD1_2,
  payload,
});

export const setCard22 = (payload) => ({
  type: actionTypes.SET_CARD2_2,
  payload,
});

export const setCard32 = (payload) => ({
  type: actionTypes.SET_CARD3_2,
  payload,
});

export const setCard42 = (payload) => ({
  type: actionTypes.SET_CARD4_2,
  payload,
});

export const setDoublesuit2 = (payload) => ({
  type: actionTypes.SET_DOUBLESUIT_2,
  payload,
});

export const setBB2 = (payload) => ({
  type: actionTypes.SET_BB_2,
  payload,
});

export const setGgps2 = (payload) => ({
  type: actionTypes.SET_GGPS_2,
  payload,
});

export const setTS2 = (payload) => ({
  type: actionTypes.SET_TS_2,
  payload,
});

export const setStake2 = (payload) => ({
  type: actionTypes.SET_STAKE_2,
  payload,
});

export const setSuit2 = (payload) => ({
  type: actionTypes.SET_SUIT_2,
  payload,
});

export const setSuitQuality2 = (payload) => ({
  type: actionTypes.SET_SUIT_QUALITY_2,
  payload,
});
